export default "__VITE_ASSET__C$ljnZ_H__"